module.exports = __webpack_public_path__ + "img/swiper-1.4fa51e9.png";